import { render, staticRenderFns } from "./CampusItem.vue?vue&type=template&id=398a1d6b&"
import script from "./CampusItem.vue?vue&type=script&lang=ts&"
export * from "./CampusItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports